import asyncEachSeries from 'async/eachSeries';
import asyncSeries from 'async/series';

import util from './util';

export default {
  closeStream,
  createReadableStream,
  createWritableStream,
  copyFile,
};
export function closeStream(
  stream: WritableStream,
  done?: (err?: any) => void
) {
  try {
    if (typeof stream?.close === 'function') {
      const p = stream.close();
      if (typeof p?.then === 'function') {
        p.then(
          () => {
            done?.();
          },
          (err) => {
            util.errorLog('File.closeStream: close err:', err);
            done?.(err);
          }
        );
      } else {
        done?.();
      }
    } else {
      done?.();
    }
  } catch (e) {
    util.errorLog('File.closeStream: threw:', e);
    done?.(e);
  }
}
export function createReadableStream(params, done) {
  const { root, path } = params;

  let handle;
  let stream;
  asyncSeries(
    [
      (done) => {
        const opts = { root, path, handle_opts: {} };
        _getHandle(opts, (err, new_handle) => {
          if (err) {
            util.errorLog('File.createReadableStream: handle err:', err);
          }
          handle = new_handle;
          done(err);
        });
      },
      (done) =>
        handle.getFile().then(
          (file) => {
            stream = file.stream();
            done();
          },
          (err) => {
            util.errorLog('File.createReadableStream: file err:', err);
            done(err);
          }
        ),
    ],
    (err) => done(err, stream)
  );
}
export function createWritableStream(params, done) {
  const { root, path, resume } = params;

  let handle;
  let file;
  let stream;
  asyncSeries(
    [
      (done) => {
        const opts = { root, path, handle_opts: { create: true } };
        _getHandle(opts, (err, new_handle) => {
          if (err) {
            util.errorLog('File.createWritableStream: handle err:', err);
          }
          handle = new_handle;
          done(err);
        });
      },
      (done) => {
        if (resume) {
          handle.getFile().then(
            (new_file) => {
              file = new_file;
              done();
            },
            (err) => {
              util.errorLog('File._createWritableStream: get file err:', err);
              done(err);
            }
          );
        } else {
          done();
        }
      },
      (done) => {
        const opts: any = { mode: 'exclusive' };
        if (resume) {
          opts.keepExistingData = true;
        }
        handle.createWritable(opts).then(
          (new_stream) => {
            stream = new_stream;
            done();
          },
          (err) => {
            util.errorLog('File.createWritableStream: stream err:', err);
            done(err);
          }
        );
      },
      (done) => {
        if (resume && file.size > 0) {
          stream.seek(file.size).then(
            () => {
              done();
            },
            (err) => {
              util.errorLog('File.createWritableStream: seek err:', err);
              done(err);
            }
          );
        } else {
          done();
        }
      },
    ],
    (err) => done(err, stream, file)
  );
}
export function copyFile(params, done) {
  const { root, src, dest } = params;

  let read;
  let write;
  asyncSeries(
    [
      (done) =>
        createReadableStream({ root, path: src }, (err, stream) => {
          if (err) {
            util.errorLog('File.copy: read err:', err);
          }
          read = stream;
          done(err);
        }),
      (done) =>
        createWritableStream({ root, path: dest }, (err, stream) => {
          if (err) {
            util.errorLog('File.copy: write err:', err);
          }
          write = stream;
          done(err);
        }),
      (done) => {
        read.pipeTo(write).then(
          () => done(),
          (err) => {
            util.errorLog('File.copy: pipe err:', err);
            closeStream(read);
            closeStream(write);
            done(err);
          }
        );
      },
    ],
    done
  );
}
function _getHandle(params, done) {
  const { root, path, handle_opts } = params;
  const path_list = path.split('/');
  const basename = path_list.splice(-1);

  let dir = root;
  let handle;
  asyncSeries(
    [
      (done) =>
        asyncEachSeries(
          path_list,
          (part_path, done) => {
            dir.getDirectoryHandle(part_path, handle_opts).then(
              (new_dir) => {
                dir = new_dir;
                done();
              },
              (err) => {
                util.errorLog('File._getHandle: dir err:', err);
                done(err);
              }
            );
          },
          done
        ),
      (done) => {
        dir.getFileHandle(basename, handle_opts).then(
          (new_handle) => {
            handle = new_handle;
            done();
          },
          (err) => {
            util.errorLog('File._getHandle: handle err:', err);
            done(err);
          }
        );
      },
    ],
    (err) => done(err, handle)
  );
}
